import PrimaryButton from '../../../components/UI/Buttons/PrimaryButton';
import Modal from '../../../components/UI/Modals/Modal';
import Spinner from '../../../components/UI/Spinner/Spinner';
import { client } from '../../../networking/client';
import { selectBase64Document, selectBase64DocumentStatus } from '../../../store/slices/documents';
import { useAppSelector } from '../../../store/store';
import fileDownload from 'js-file-download';

import classes from './PreviewDocumentModal.module.css';

import { selectBusinessPartnerId } from '../../../store/slices/auth';
import { useTranslation } from '../../../hooks/useTranslations';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  documentFilename: string;
  documentMimeType: string;
};

const PreviewDocumentModal: React.FC<Props> = ({
  isOpen,
  onClose,
  documentFilename,
  documentMimeType,
}) => {
  const base64Document = useAppSelector<string>(selectBase64Document);
  const base64DocumentStatus = useAppSelector<string>(selectBase64DocumentStatus);
  const { translations } = useTranslation();
  const businessPartnerId = useAppSelector<string>(selectBusinessPartnerId);

  return (
    <Modal width="80%" containerPadding="40px" isOpen={isOpen} onClose={onClose}>
      <div className={classes.container}>
        {base64DocumentStatus === 'pending' ? (
          <Spinner />
        ) : documentMimeType === 'application/jpeg' ? (
          <img src={`data:${documentMimeType};base64,${base64Document}`} alt="document" />
        ) : (
          <iframe
            title={translations('document').toString()}
            src={`data:${documentMimeType};base64,${base64Document}`}
            className={classes.iframe}
          ></iframe>
        )}
      </div>
      <PrimaryButton
        text={translations('download')}
        containerStyle={{ marginTop: '20px' }}
        disabled={false}
        onClick={async () => {
          try {
            const response = await client.get(
              `/healthpoint/download-document/${documentFilename}/${businessPartnerId}`,
              {
                responseType: 'blob',
              }
            );
            fileDownload(response.data, documentFilename);
          } catch (_) {}
        }}
      />
    </Modal>
  );
};
export default PreviewDocumentModal;
